import constants from '#packages/constants';

const { POPUP_CONTAINER } = constants.COMP_TYPES;

export const RESTRICTED_SAVED_COMPONENTS = new Set<string>([POPUP_CONTAINER]);
